var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllianceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 49,
    viewBox: "0 0 60 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0016 38.648H18.3817L24.1895 29.2623L30.0016 19.8787L35.8094 29.2623L41.6162 38.648H30.0016ZM32.3509 16.3255L34.06 13.1071L56.0905 48.4718H60L45.0003 24.2348L33.8611 6.23816L14.2181 38.6075L10.5043 38.648L31.9978 3.22653L30.0016 -3.93321e-05L15.0019 24.2348L4.16151 41.7469H42.9881L44.9152 44.8457H2.24187L0 48.4718H30.0016H52.3746L32.3509 16.3255",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllianceWhite);
export default __webpack_public_path__ + "static/media/alliance_white.9f4d1cfb8c50c40e8db09b44dd41b182.svg";
export { ForwardRef as ReactComponent };